import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import copyToClipboard from '~/utils/copyToClipboard';

/** How long `copied` stays true after a successful copy. */
const COPIED_MS = 2000;

/**
 * Copies the address of the current page to the clipboard with the shared
 * toast, and reports `copied` for two seconds afterwards so the button can
 * show a check.
 */
export const useCopyLink = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    const timer = window.setTimeout(() => setCopied(false), COPIED_MS);

    return () => window.clearTimeout(timer);
  }, [copied]);

  const copyLink = () => {
    copyToClipboard({
      text: window.location.href,
      successMessage: t('linkCopied'),
    })
      .then(() => setCopied(true))
      .catch(console.error);
  };

  return { copied, copyLink };
};
